import * as yup from 'yup'

const REQUIRED_MESSAGE = 'This field is required'

export const EditAs2CertificateModalSchema = yup.object({
  /**
   * @example '12'
   */
  id: yup.string().required(REQUIRED_MESSAGE),
  /**
   * @example '-----BEGIN CERTIFICATE-----MIIG5DCCBcygAwIBAgIRALk....RgfFA==-----END CERTIFICATE-----
   */
  body: yup.string().required(REQUIRED_MESSAGE),
})

export type TEditAs2CertificateModalSchema = yup.InferType<typeof EditAs2CertificateModalSchema>
